import React from "react";
import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";
import { telHref, mailHref } from "@/lib/content";

export default function Footer() {
  const { contact } = useContent();
  return (
    <footer data-testid="footer" className="bg-foreground text-background">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-20 md:py-28">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <p className="text-xs uppercase tracking-label text-background/50 mb-6">Hagelund ApS</p>
            <h2 className="font-display text-4xl md:text-6xl font-light leading-[1.05] max-w-xl">
              Lad os tale om den rigtige løsning til dit hus.
            </h2>
            <Link
              to="/kontakt"
              data-testid="footer-cta"
              className="inline-block mt-10 text-sm uppercase tracking-label border-b border-background/40 pb-1 hover:border-background transition-colors"
            >
              Book rådgivning
            </Link>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-label text-background/50 mb-6">Kontakt</p>
            <ul className="space-y-3 text-background/85 font-light">
              <li>
                <a href={telHref(contact.phone)} className="hover:text-white" data-testid="footer-phone">
                  {contact.phone}
                </a>
              </li>
              <li>
                <a href={mailHref(contact.email)} className="hover:text-white break-all" data-testid="footer-email">
                  {contact.email}
                </a>
              </li>
              <li className="text-background/60 pt-2">{contact.address}</li>
              <li className="text-background/60">CVR {contact.cvr}</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-label text-background/50 mb-6">Menu</p>
            <ul className="space-y-3 text-background/85 font-light">
              <li><Link to="/doere" className="hover:text-white">Døre</Link></li>
              <li><Link to="/vinduer" className="hover:text-white">Vinduer</Link></li>
              <li><Link to="/cases" className="hover:text-white">Cases</Link></li>
              <li><Link to="/om-os" className="hover:text-white">Om os</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-background/15 flex flex-col md:flex-row justify-between gap-4 text-xs uppercase tracking-label text-background/45">
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <span>&copy; {new Date().getFullYear()} Hagelund ApS</span>
            <Link to="/privatlivspolitik" className="hover:text-background transition-colors">Privatlivspolitik</Link>
            <Link to="/cookiepolitik" className="hover:text-background transition-colors">Cookiepolitik</Link>
            <button
              type="button"
              data-testid="footer-change-consent"
              onClick={() => window.hgOpenConsent && window.hgOpenConsent()}
              className="hover:text-background transition-colors uppercase tracking-label text-xs"
            >
              Ændr cookiesamtykke
            </button>
          </div>
          <span className="font-display text-lg tracking-[0.3em] text-background/70">HAGELUND</span>
        </div>
      </div>
    </footer>
  );
}
